import { render } from "./StackChart.vue?vue&type=template&id=4c855dad&scoped=true"
import script from "./StackChart.vue?vue&type=script&lang=js"
export * from "./StackChart.vue?vue&type=script&lang=js"

import "./StackChart.vue?vue&type=style&index=0&id=4c855dad&scoped=true&lang=css"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c855dad"]])

export default __exports__